import { useState } from "react";
import { useSelector } from "react-redux";
import { ButtonPushComponent, TitleComponent } from "../../components";
import { ModalLayout } from "../../layouts";
import { ModalContainer } from "../ModalContainer/ModalContainer";
import { requestPatchFileAuthorization } from "../../services/requestPatch";
import { useNavigate } from "react-router-dom";
import {
  processPhotoFormData,
  processPhotosArray,
} from "../../helpers/convertToFormData";

const photoFields = [
  { fieldName: "coverDesktop", dataField: "coverDesktop" },
  { fieldName: "coverMobile", dataField: "coverMobile" },
];

export const SettingLandingBannersAlliesHeaderContainer = () => {
  const { bannerAlliesData } = useSelector(
    (state) => state.retrieveBannerAllies
  );
  const [isOpenUpdate, setIsOpenUpdate] = useState(false);
  const toggleModalUpdate = () => {
    setIsOpenUpdate(!isOpenUpdate);
  };
  const navigate = useNavigate();
  const handleUpdate = async () => {
    let body = { ...bannerAlliesData };
    const formData = new FormData();

    await processPhotoFormData(body, formData, photoFields);
    await processPhotosArray(
      body?.companies,
      formData,
      "companies",
      "photo",
      "slug"
    );

    await requestPatchFileAuthorization(
      "admin/banners/aliados/",
      formData
    ).then(() => {
      navigate("/configuracion/landing/banners");
    });
  };
  return (
    <section className="OrderDetailHeaderContainer">
      <div className="OrderDetailHeaderContainer__title">
        <TitleComponent title="Aliados" />
      </div>
      <div className="OrderDetailHeaderContainer__container-button">
        <ButtonPushComponent
          name={"Actualizar Aliados"}
          onClick={toggleModalUpdate}
        />
      </div>
      {isOpenUpdate && (
        <ModalLayout>
          <ModalContainer
            title="Actualizar Aliados"
            msg="¿Está seguro que desea actualizar Aliados?"
            onClose={toggleModalUpdate}
            onConfirm={handleUpdate}
          />
        </ModalLayout>
      )}
    </section>
  );
};
